module.exports = __webpack_public_path__ + "static/media/24_A.0a8c7c92.png";